// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const TrashIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M21 7H3a1 1 0 010-2h18a1 1 0 010 2z"/><path d="M17 23H7a3 3 0 01-3-3V6a1 1 0 012 0v14a1 1 0 001 1h10a1 1 0 001-1V6a1 1 0 012 0v14a3 3 0 01-3 3zM16 7a1 1 0 01-1-1V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v2a1 1 0 01-2 0V4a3 3 0 013-3h4a3 3 0 013 3v2a1 1 0 01-1 1z"/><path d="M10 18a1 1 0 01-1-1v-6a1 1 0 012 0v6a1 1 0 01-1 1zm4 0a1 1 0 01-1-1v-6a1 1 0 012 0v6a1 1 0 01-1 1z"/></svg>'} />;

TrashIcon.displayName = 'TrashIcon';

export default TrashIcon;
